/**
 * Color palette for path visualization
 * Colors are chosen to be distinct and accessible
 */
const PATH_COLORS = [
  { main: '#1976d2', light: '#e3f2fd', dark: '#1565c0' }, // Blue
  { main: '#2e7d32', light: '#e8f5e9', dark: '#1b5e20' }, // Green
  { main: '#ed6c02', light: '#fff3e0', dark: '#e65100' }, // Orange
  { main: '#1e88e5', light: '#e3f2fd', dark: '#1565c0' }, // Medium Blue (was Purple)
  { main: '#d32f2f', light: '#ffebee', dark: '#c62828' }, // Red
  { main: '#0288d1', light: '#e1f5fe', dark: '#0277bd' }, // Light Blue
  { main: '#388e3c', light: '#e8f5e9', dark: '#2e7d32' }, // Light Green
  { main: '#f57c00', light: '#fff8e1', dark: '#e65100' }, // Amber
  { main: '#1976d2', light: '#e3f2fd', dark: '#1565c0' }, // Blue (was Deep Purple)
  { main: '#c2185b', light: '#fce4ec', dark: '#ad1457' }, // Pink
];

/**
 * Generate a consistent color for a path based on its ID
 */
export function getPathColor(pathId: string): { main: string; light: string; dark: string } {
  // Simple hash function to get consistent color for same path ID
  let hash = 0;
  for (let i = 0; i < pathId.length; i++) {
    hash = pathId.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % PATH_COLORS.length;
  return PATH_COLORS[index];
}

/**
 * Get a color by index (for predictable assignment)
 */
export function getPathColorByIndex(index: number): { main: string; light: string; dark: string } {
  return PATH_COLORS[index % PATH_COLORS.length];
}

